import styled from 'styled-components';

export const H1 = styled.h1`
  font-size: ${({ theme }) => theme.text.fontSize.xxl};
  font-weight: ${({ theme }) => theme.text.fontWeight.medium};
  color: ${({ theme }) => theme.colors.text};
  opacity: ${({ theme }) => theme.emphasis.high};
  font-family: 'ProductSansBold';
`;
